module.exports = __webpack_public_path__ + "img/defaultHead.d5cb3.jpeg";